<div class="dxc-numfield__box" [class.is-invalid]="invalid" [class.is-disabled]="disabled">
  @if (steppers) {
    <button type="button" class="dxc-numfield__step" tabindex="-1"
      [disabled]="disabled || atMin" aria-label="Restar"
      (mousedown)="$event.preventDefault()" (click)="nudge(-1)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>
    </button>
  }

  <input type="text" class="dxc-numfield__input" inputmode="decimal" autocomplete="off"
    [id]="fieldId" [disabled]="disabled" [value]="text" [placeholder]="placeholder"
    [attr.aria-label]="ariaLabel || null"
    (input)="onType($any($event.target).value)" (keydown)="onKeydown($event)" (blur)="onBlur()">

  @if (steppers) {
    <button type="button" class="dxc-numfield__step" tabindex="-1"
      [disabled]="disabled || atMax" aria-label="Sumar"
      (mousedown)="$event.preventDefault()" (click)="nudge(1)">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>
    </button>
  }

  @if (suffix && !units.length) {
    <span class="dxc-numfield__suffix">{{ suffix }}</span>
  }

  @if (units.length) {
    <span class="dxc-numfield__units" role="group" aria-label="Unidad">
      @for (option of units; track option) {
        <button type="button" [disabled]="disabled" [attr.aria-pressed]="unit === option"
          (click)="setUnit(option)">{{ option }}</button>
      }
    </span>
  }
</div>
